import type { SVGProps } from "react";

import { brandIconA11y } from "@/components/icons/brandIconA11y";

/**
 * OpenRouter's brand mark.
 *
 * The bundled icon sets (Font Awesome brands, react-icons/si) still have no
 * entry for it, so for a while a Lucide `Route` glyph stood in — which read
 * as "a route", not as OpenRouter. This is the real mark as Simple Icons
 * publishes it (CC0, https://simpleicons.org/?q=openrouter), a single path on
 * a 24×24 box drawn in `currentColor`, so `text-openrouter` colours it like
 * the OpenAI and Anthropic marks.
 */
export function OpenRouterIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...brandIconA11y(props)}
      className={className}
      {...props}
    >
      <path d="M16.778 1.844v1.919q-.569-.026-1.138-.032-.708-.008-1.415.037c-1.93.126-4.023.728-6.149 2.237-2.911 2.066-2.731 1.95-4.14 2.75-.396.223-1.342.574-2.185.798-.841.225-1.753.333-1.751.333v4.229s.768.108 1.61.333c.842.224 1.789.575 2.185.799 1.41.798 1.228.683 4.14 2.75 2.126 1.509 4.22 2.11 6.148 2.236.88.058 1.716.041 2.555.005v1.918l7.222-4.168-7.222-4.17v2.176c-.86.038-1.611.065-2.278.021-1.364-.09-2.417-.357-3.979-1.465-2.244-1.593-2.866-2.027-3.68-2.508.889-.518 1.449-.906 3.822-2.59 1.56-1.109 2.614-1.377 3.978-1.466.667-.044 1.418-.017 2.278.02v2.176L24 6.014Z" />
    </svg>
  );
}
